import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import moment from "moment";

function ListadoEmbarques() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_EMBARQUES = process.env.REACT_APP_URL_EMBARQUES;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_ARTICULOS_OC_ACUMULADOS = process.env.REACT_APP_URL_ARTICULOS_OC_ACUMULADOS;
  const URL_CONCEPTOS_GASTOS_EMBARQUES =
    process.env.REACT_APP_URL_CONCEPTOS_GASTOS_EMBARQUES;
  const URL_GASTOS_EMBARQUES = process.env.REACT_APP_URL_GASTOS_EMBARQUES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;

   let date = new Date();
    let hoy = moment(date).format("YYYY-MM-DD");

  const [embarques, setEmbarques] = useState([]);
  const [numeroEmbarque, setNumeroEmbarque] = useState([]);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState("");

  const [fechaEmbarque, setFechaEmbarque] = useState("");
  const [fechaEstimada, setFechaEstimada] = useState("");
  const [tipoCambioUSDMXN, setTipoCambioUSDMXN] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [contenedor, setContenedor] = useState("");
  const [numeroInterno, setNumeroInterno] = useState("");
  const [idEdit, setIdEdit] = useState("");
  const [idProveedor, setIdProveedor] = useState("");
  const [idProveedorEdit, setIdProveedorEdit] = useState("");
  const [idContenedor, setIdContenedor] = useState("");
  const [idNotaCxP, setIdNotaCxP] = useState("");

  const [articulosOC, setArticulosOC] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [proveedores, setProveedores] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);
  const [totalCaptura, setTotalCaptura] = useState(1000000);

  const [gastosEmbarque, setGastosEmbarque] = useState([]);
  const [modalEditGastos, setModalEditGastos] = useState(false);
  const toggleEditGastos = () => setModalEditGastos(!modalEditGastos);
  const [total_cantidadGastos, setTotalCantidadGastos] = useState(0);
  const [gastosEmbarquesTotales, setGastosEmbarquesTotales] = useState(0);
  const [conceptosGastos, setConceptosGastos] = useState([]);

  const [modalEditFOB, setModalEditFOB] = useState(false);
  const toggleEditFOB = () => setModalEditFOB(!modalEditFOB);
    const [articulosPedido, setArticulosPedido] = useState([]);

  const [gasto1Concepto, setGasto1Concepto] = useState("");
  const [gasto1USD, setGasto1USD] = useState(0);
  const [gasto1TC, setGasto1TC] = useState(0);
  const [gasto1MXN, setGasto1MXN] = useState(0);
  const [gasto2Concepto, setGasto2Concepto] = useState("");
  const [gasto2USD, setGasto2USD] = useState(0);
  const [gasto2TC, setGasto2TC] = useState(0);
  const [gasto2MXN, setGasto2MXN] = useState(0);
  const [gasto3Concepto, setGasto3Concepto] = useState("");
  const [gasto3USD, setGasto3USD] = useState(0);
  const [gasto3TC, setGasto3TC] = useState(0);
  const [gasto3MXN, setGasto3MXN] = useState(0);
  const [gasto4Concepto, setGasto4Concepto] = useState("");
  const [gasto4USD, setGasto4USD] = useState(0);
  const [gasto4TC, setGasto4TC] = useState(0);
  const [gasto4MXN, setGasto4MXN] = useState(0);
  const [tipoCambioArticulos, setTipoCambioArticulos] = useState(18);

  const [totalCantidad, setTotalCantidad] = useState(0);
  const [totalGeneral, setTotalGeneral] = useState(0);

  const [inputFieldsGastos, setInputFieldsGastos] = useState([
    {
      id: uuidv4(),
      concepto: "",
      estimado: 0,
      real: 0,
    },
  ]);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulosOrden: "",
      articulos: "",
      cantidad: 0,
      piezasPorCaja: 0,
      cajas: 0,
      cantidadOC: 0,
      costo: 0,
      costoTotal: 0,
      proveedorOrden: "",
    },
  ]);

    const [inputFieldsNuevos, setInputFieldsNuevos] = useState([
    {
      id: uuidv4(),
        articulosOrden: "",
        articulos: "",
        cantidad: 0,
        piezasPorCaja: 0,
        cajas: 0,
        cantidadOC: 0,
        costo: 0,
        costoTotal: 0,
        proveedorOrden: idProveedor,
        ordenCompra: "",
        CBM: 0,
        comisionVendedorPorcentaje: 0,
        comisionVendedorCantidad: 0,

    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [contenedorEdit, setContenedorEdit] = useState("");
  const [articulosOrden, setArticulosOrden] = useState([]);
  const [totalCantidadEdit, setTotalCantidadEdit] = useState("");
  const [totalGeneralEdit, setTotalGeneralEdit] = useState("");
  const [agrupado, setAgrupado] = useState([]);
  const [idArtEdit, setIdArtEdit] = useState("");
  const [recibidoEdit, setRecibidoEdit] = useState("");

  const [recibido, setRecibido] = useState("");
  const [costeado, setCosteado] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_EMBARQUES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmbarques = response.data;
        // Array para pagination
        let arrayTabla = allEmbarques
          .sort((a, b) => (a.idEmbarques > b.idEmbarques ? 1 : -1))
          .map((a) => {
            // if(a.total_cantidad > 0){
            return {
              is_active: a.is_active,
              recibido: a.recibido,
              _id: a._id,
              numero: a.idEmbarques,
              fechaEmbarque: a.fechaEmbarque,
              fechaEstimada: a.fechaEstimada,
              numeroInterno: a.numeroInterno,
              tipoCambioUSDMXN: a.tipoCambioUSDMXN,
              observaciones: a.observaciones,
              contenedor: a.contenedor,
              totalCantidad: parseFloat(a.total_cantidad).toFixed(2),
              total_gasto: parseFloat(a.total_gasto).toFixed(2),
              costeado: a.costeado,
              proveedor: a.proveedores[0].nombre_comercial,
              idProveedor: a.proveedores[0]._id,
              creado: a.creado[0].nombre + " " + a.creado[0].apellido,
              idCreado: a.creado[0]._id,
              total_costo: parseFloat(a.total_costo).toFixed(2),
              gasto1Concepto: a.gasto1Concepto,
              gasto1USD: a.gasto1USD,
              gasto1TC: a.gasto1TC,
              gasto1MXN: a.gasto1MXN,
              gasto2Concepto: a.gasto2Concepto,
              gasto2USD: a.gasto2USD,
              gasto2TC: a.gasto2TC,
              gasto2MXN: a.gasto2MXN,
              gasto3Concepto: a.gasto3Concepto,
              gasto3USD: a.gasto3USD,
              gasto3TC: a.gasto3TC,
              gasto3MXN: a.gasto3MXN,
              gasto4Concepto: a.gasto4Concepto,
              gasto4USD: a.gasto4USD,
              gasto4TC: a.gasto4TC,
              gasto4MXN: a.gasto4MXN,
              // proveedor: a.proveedores[0].nombre_comercial,
              // idProveedor: a.proveedores[0]._id,
            }
          // }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setEmbarques(allEmbarques);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
    axios
        .get(URL_ARTICULOS_OC_ACUMULADOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosOC = res.data;
        setArticulosOC(allArticulosOC);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
    .get(`${URL_PROVEEDORES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CONCEPTOS_GASTOS_EMBARQUES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allConceptosGastos = res.data;
        setConceptosGastos(allConceptosGastos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const ListaEmbarques = comments.sort((a, b) =>
    a.idEmbarques > b.idEmbarques ? 1 : -1
  );

  function PDFTabla() {
    const data = ListaEmbarques.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (recibido == 0 || recibido == a.recibido)
      ) {
        return [
          a.recibido,
          a.numero,
          a.fechaEmbarque,
          a.contenedor,
          a.numeroInterno,
          a.fechaEstimada,
          a.observaciones,
          new Intl.NumberFormat("en-US").format(a.totalCantidad),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 40, 30);
    doc.text(`Listado de Embarques`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Recibido",
          "Numero",
          "Fecha Embarque",
          "Contenedor",
          "Numero Interno",
          "Fecha Estimada",
          "Observaciones",
          "Cantidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Embarques.pdf`);
  }

  function excel() {
    const dataExcel = ListaEmbarques.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (recibido == 0 || recibido == a.recibido)
      ) {
        return {
          Recibido: a.recibido,
          Numero: a.numero,
          FechaEmbarque: a.fechaEmbarque,
          Contenedor: a.contenedor,
          NumeroInterno: a.numeroInterno,
          FechaEstimada: a.fechaEstimada,
          Observaciones: a.observaciones,
          Cantidad: a.totalCantidad,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoEmbarques";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoEmbarques",
        sheetFilter: [
          "Recibido",
          "Numero",
          "FechaEmbarque",
          "Contenedor",
          "NumeroInterno",
          "FechaEstimada",
          "Observaciones",
          "Cantidad",
        ],
        sheetHeader: [
          "Recibido",
          "Numero",
          "FechaEmbarque",
          "Contenedor",
          "NumeroInterno",
          "FechaEstimada",
          "Observaciones",
          "Cantidad",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaEmbarques.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (recibido == 0 || recibido == a.recibido)
      ) {
        return [
          a.recibido,
          a.numero,
          a.fechaEmbarque,
          a.contenedor,
          a.numeroInterno,
          a.fechaEstimada,
          a.observaciones,
          new Intl.NumberFormat("en-US").format(a.totalCantidad),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 40, 30);
    doc.text(`Listado de Embarques`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Recibido",
          "Numero",
          "Fecha Embarque",
          "Contenedor",
          "Numero Interno",
          "Fecha Estimada",
          "Observaciones",
          "Cantidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Embarques",
          email: mailTo,
          fileName: "ListadoEmbarques.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Embarques.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  async function PDFOC(
    fechaEmbarque,
    contenedor,
    numeroInterno,
    fechaEstimada,
    creado,
    idPDFOC,
    numero
  ) {
    let totalCajas= 0
    await axios
      .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrden = response.data;
        let arrayTabla = allArticulosOrden
          .map((a) => {
            return {
              id: a._id,
              proveedor: a.proveedores[0].nombre_comercial,
              articulo: a.articulos[0].SKU,
              nombreArticulo: a.articulos[0].nombre,
              // OC: a.articulosOC[0].ordenesCompra[0].idOrdenCompra,
              pzasXcaja: a.articulos[0].piezasPorCaja,
              cantidad: a.cantidad,
              cajas: parseFloat(a.cantidad) / parseFloat(a.articulos[0].piezasPorCaja),
              FOB: a.costoUSD,
              total_costo: a.total_costo
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidad(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total_costo));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneral(TG);

        const data = dataFinal.map((a) => {
          totalCajas = totalCajas + a.cajas
          return [
            a.proveedor,
            a.articulo,
            a.nombreArticulo,
            // a.OC,
            new Intl.NumberFormat("en-US").format(a.pzasXcaja),
            new Intl.NumberFormat("en-US").format(a.cantidad),
            new Intl.NumberFormat("en-US").format(a.cajas),
            "$" + new Intl.NumberFormat("en-US").format(a.FOB),
            "$" + new Intl.NumberFormat("en-US").format(a.total_costo),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape", "mm", "a4", true);
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 230, 30, 45, 15);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 125, 10, 40, 30);
        doc.text(`Contenedor # ${contenedor} ${numeroInterno}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha Embarque ${fechaEmbarque}`, 20, 25);
        doc.text(`Fecha Estimada ${fechaEstimada}`, 20, 30);
        doc.text(`Creado por ${creado}`, 20, 35);
        doc.autoTable({
          head: [
            [
              "Proveedor",
              "SKU",
              "Articulo",
              // "OC",
              "Pzs Caja",
              "Cantidad",
              "Cajas",
              "FOB",
              "Total",
            ],
          ],
          body: dataPDFLimpia,
          startY: 45,
          footStyles: {
            fontSize: 12,
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
          },
          foot: [
            [
              "",
              "",
              "",
              "Total",
              new Intl.NumberFormat("en-US").format(TC),
              new Intl.NumberFormat("en-US").format(totalCajas),
              "",
              "$" + new Intl.NumberFormat("en-US").format(TG),
            ],
          ],
          showFoot: "lastPage",
        });
        // doc.save(`Embarque-${numero}.pdf`);
        window.open(doc.output("bloburl"), "_blank");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function jalaInfo(
    fechaEmbarque,
    fechaEstimada,
    numeroInterno,
    tipoCambioUSDMXN,
    observaciones,
    contenedor,
    numero,
    recibido,
    idEdit
  ) {
    setFechaEmbarque(fechaEmbarque);
    setNumeroInterno(numeroInterno);
    setFechaEstimada(fechaEstimada);
    setTipoCambioUSDMXN(tipoCambioUSDMXN);
    setObservaciones(observaciones);
    setContenedor(contenedor);
    setNumeroEmbarque(numero);
    setRecibidoEdit(recibido)
    setIdEdit(idEdit);
    toggleEdit();
  }

  function editEmbarques(event) {
    event.preventDefault();
    const URL_EMBARQUES_EDIT = `${process.env.REACT_APP_URL_EMBARQUES}/${idEdit}`;
    axios
      .all([
        axios.patch(
          URL_EMBARQUES_EDIT,
          {
            fechaEmbarque,
            fechaEstimada,
            numeroInterno,
            tipoCambioUSDMXN,
            observaciones,
            contenedor,
            recibido: recibidoEdit
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        ),
      ])
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Embarque",
            detalle: `${numeroEmbarque}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
        setComments((prev) =>
          prev.map((embarque) =>
            embarque._id === idEdit
              ? {
                  ...embarque,
                  fecha: fechaEmbarque,
                  fechaEstimada,
                  numeroInterno,
                  tipoCambioUSDMXN,
                  observaciones,
                  contenedor,
                  recibido: recibidoEdit,
                }
              : embarque
          )
        );
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Activo", field: "is_active", sortable: true },
    { name: "Recibido", field: "recibido", sortable: true },
    { name: "Costeado", field: "costeado", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha Embarque", field: "fechaEmbarque", sortable: false },
    { name: "Proveedor", field: "proveedor", sortable: false },
    { name: "Contenedor", field: "contenedor", sortable: true },
    { name: "Numero Interno", field: "numeroInterno", sortable: true },
    { name: "Fecha Estimada", field: "fechaEstimada", sortable: false },
    { name: "Cantidad", field: "totalCantidad", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.recibido.toLowerCase().includes(search.toLowerCase()) ||
          comment.costeado.toLowerCase().includes(search.toLowerCase()) ||
          comment.is_active.toLowerCase().includes(search.toLowerCase()) ||
          comment.contenedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroInterno.toLowerCase().includes(search.toLowerCase()) ||
          comment.totalCantidad.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (recibido) {
      computedComments = computedComments.filter((e) =>
        e.recibido.includes(recibido)
      );
    }

    if (costeado) {
      computedComments = computedComments.filter((e) =>
        e.costeado.includes(costeado),
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fechaEmbarque >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fechaEmbarque <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "totalCantidad" &&
      sorting.field &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "totalCantidad" ||
        sorting.field ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "totalCantidad" ||
        sorting.field ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    recibido,
    costeado,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

  function EditArticulos(
    idOC,
    idProveedor,
    totalCantidad,
    total_costo,
    tipoCambioUSDMXN,
    gasto1Concepto,
    gasto1USD,
    gasto1TC,
    gasto1MXN,
    gasto2Concepto,
    gasto2USD,
    gasto2TC,
    gasto2MXN,
    gasto3Concepto,
    gasto3USD,
    gasto3TC,
    gasto3MXN,
    gasto4Concepto,
    gasto4USD,
    gasto4TC,
    gasto4MXN
  ) {
    // setInputFields([
    //   {
    //     id: uuidv4(),
    //     articulos: "",
    //     piezasPorCaja: 0,
    //     cajas: 0,
    //     cantidad: 0,
    //     precio: 0,
    //     precioBruto: 0,
    //     total: 0,
    //     cliente: ""
    //   },
    // ]);
    setIdEdit(idOC);
    setIdProveedorEdit(idProveedor);
    setTotalCantidadEdit(totalCantidad);
    setTotalGeneralEdit(total_costo);
    setTipoCambioUSDMXN(tipoCambioUSDMXN);
    setGasto1Concepto(gasto1Concepto);
    setGasto1USD(gasto1USD);
    setGasto1TC(gasto1TC);
    setGasto1MXN(gasto1MXN);
    setGasto2Concepto(gasto2Concepto);
    setGasto2USD(gasto2USD);
    setGasto2TC(gasto2TC);
    setGasto2MXN(gasto2MXN);
    setGasto3Concepto(gasto3Concepto);
    setGasto3USD(gasto3USD);
    setGasto3TC(gasto3TC);
    setGasto3MXN(gasto3MXN);
    setGasto4Concepto(gasto4Concepto);
    setGasto4USD(gasto4USD);
    setGasto4TC(gasto4TC);
    setGasto4MXN(gasto4MXN);
    axios
      .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = allArticulosPedido
          .map((a) => {
            return {
              id: a._id,
              idArticulos: a.articulos[0]._id,
              articulo: a.articulos[0].SKU + " " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              cantidadAnterior: a.cantidad,
              costoUSD: a.costoUSD,
              total: a.total_costo,
              CBM: a.CBM,
              recibido: a.recibido,
              pendiente_recibir: a.pendiente_recibir,
              comisionVendedorPorcentaje: a.comisionVendedorPorcentaje,
              comisionVendedorCantidad: a.comisionVendedorCantidad,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setArticulosPedido(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });
      toggleEditFOB();
  }


const handleCostoChange = (index, value) => {
  const updated = [...articulosPedido];
  updated[index].costoUSD = value;

  const costoUSD = Number(value || 0);
  const cantidad = Number(updated[index].cantidad || 0);
  const cbm = Number(updated[index].CBM || 0);

  // const fobPesos = costoUSD * promedioTipoCambioGastos;
  const fobPesos = costoUSD * tipoCambioArticulos;
  const totalCBMUSD = costoCBMUSDGlobal * cbm;
  // const totalCBMPesos = totalCBMUSD * promedioTipoCambioGastos;
  const totalCBMPesos = totalCBMUSD * tipoCambioArticulos;
  const pasadaPorPiezaUSD = cantidad > 0 ? totalCBMUSD / cantidad : 0;
  const pasadaPorPiezaPesos = cantidad > 0 ? totalCBMPesos / cantidad : 0;
  const costoUSDTotal = costoUSD + pasadaPorPiezaUSD;
  const costoPesosTotal = fobPesos + pasadaPorPiezaPesos;
  const total = costoPesosTotal * cantidad;

  updated[index].fobPesos = fobPesos;
  updated[index].costoCBMUSD = costoCBMUSDGlobal;
  updated[index].costoCBMPesos = costoCBMPesosGlobal;
  updated[index].totalCBMUSD = totalCBMUSD;
  updated[index].totalCBMPesos = totalCBMPesos;
  updated[index].pasadaPorPiezaUSD = pasadaPorPiezaUSD;
  updated[index].pasadaPorPiezaPesos = pasadaPorPiezaPesos;
  updated[index].costoUSDTotal = costoUSDTotal;
  updated[index].costoPesosTotal = costoPesosTotal; // rojo
  updated[index].total = total;

  setArticulosPedido(updated);
};

const handleCBMChange = (index, value) => {
  const updated = [...articulosPedido];
  updated[index].CBM = value;

  const costoUSD = Number(updated[index].costoUSD || 0);
  const cantidad = Number(updated[index].cantidad || 0);
  const cbm = Number(value || 0);

  // const fobPesos = costoUSD * promedioTipoCambioGastos;
  const fobPesos = costoUSD * tipoCambioArticulos;
  const totalCBMUSD = costoCBMUSDGlobal * cbm;
  // const totalCBMPesos = totalCBMUSD * promedioTipoCambioGastos;
  const totalCBMPesos = totalCBMUSD * tipoCambioArticulos;
  const pasadaPorPiezaUSD = cantidad > 0 ? totalCBMUSD / cantidad : 0;
  const pasadaPorPiezaPesos = cantidad > 0 ? totalCBMPesos / cantidad : 0;
  const costoUSDTotal = costoUSD + pasadaPorPiezaUSD;
  const costoPesosTotal = fobPesos + pasadaPorPiezaPesos;
  const total = costoPesosTotal * cantidad;

  updated[index].fobPesos = fobPesos;
  updated[index].costoCBMUSD = costoCBMUSDGlobal;
  updated[index].costoCBMPesos = costoCBMPesosGlobal;
  updated[index].totalCBMUSD = totalCBMUSD;
  updated[index].totalCBMPesos = totalCBMPesos;
  updated[index].pasadaPorPiezaUSD = pasadaPorPiezaUSD;
  updated[index].pasadaPorPiezaPesos = pasadaPorPiezaPesos;
  updated[index].costoUSDTotal = costoUSDTotal;
  updated[index].costoPesosTotal = costoPesosTotal; // rojo
  updated[index].total = total;

  setArticulosPedido(updated);
};
  const handleComisionChange = (index, value) => {
    const nuevosArticulos = [...articulosPedido];
    const porcentaje = parseFloat(value) || 0;
    const fob = parseFloat(nuevosArticulos[index].costoUSD) || 0;
  
    nuevosArticulos[index].comisionVendedorPorcentaje = porcentaje;
    nuevosArticulos[index].comisionVendedorCantidad = (fob * porcentaje) / 100;

    setArticulosPedido(nuevosArticulos);
  };

// Editar la cantidad de una linea existente (solo si NO esta recibida)
const handleCantidadChange = (index, value) => {
  const updated = [...articulosPedido];
  if (Number(updated[index].recibido) > 0) {
    return; // linea ya recibida, no se edita
  }
  updated[index].cantidad = value;

  const costoUSD = Number(updated[index].costoUSD || 0);
  const cantidad = Number(value || 0);
  const cbm = Number(updated[index].CBM || 0);

  const fobPesos = costoUSD * tipoCambioArticulos;
  const totalCBMUSD = costoCBMUSDGlobal * cbm;
  const totalCBMPesos = totalCBMUSD * tipoCambioArticulos;
  const pasadaPorPiezaUSD = cantidad > 0 ? totalCBMUSD / cantidad : 0;
  const pasadaPorPiezaPesos = cantidad > 0 ? totalCBMPesos / cantidad : 0;
  const costoUSDTotal = costoUSD + pasadaPorPiezaUSD;
  const costoPesosTotal = fobPesos + pasadaPorPiezaPesos;
  const total = costoPesosTotal * cantidad;

  updated[index].fobPesos = fobPesos;
  updated[index].totalCBMUSD = totalCBMUSD;
  updated[index].totalCBMPesos = totalCBMPesos;
  updated[index].pasadaPorPiezaUSD = pasadaPorPiezaUSD;
  updated[index].pasadaPorPiezaPesos = pasadaPorPiezaPesos;
  updated[index].costoUSDTotal = costoUSDTotal;
  updated[index].costoPesosTotal = costoPesosTotal;
  updated[index].total = total;

  setArticulosPedido(updated);
};

// Guarda una sola linea (cantidad / costoUSD / CBM) con cascada completa en el back.
// Solo aplica si la linea NO esta recibida. Es independiente del boton "Costear"
// para no doble-contar el header del embarque.
const guardarLineaNoRecibida = (ae) => {
  if (Number(ae.recibido) > 0) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "La linea ya tiene piezas recibidas, no se puede editar.",
    });
    return;
  }
  Swal.fire({
    title: "Estas seguro?",
    text: "Se actualizara la linea y todos sus totales (NotaCxP, proveedor y embarque).",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, guardar!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .patch(
          `${URL_ARTICULOS_EMBARQUES}EditLineaNoRecibida/${ae.id}`,
          {
            cantidad: Number(ae.cantidad || 0),
            costoUSD: Number(ae.costoUSD || 0),
            CBM: Number(ae.CBM || 0),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          axios.post(
            URL_LOGS,
            {
              tipo: "Editar Linea Embarque",
              detalle: `Linea ${ae.id} / ${ae.articulo}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          Swal.fire("Good job!", "Linea actualizada con exito", "success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response?.data?.message || ""}`,
          });
          console.log(error);
        });
    }
  });
};

const handleCBMChangeNuevos = (index, value) => {
  const updated = [...inputFieldsNuevos];
  updated[index].CBM = value;

  const costoUSD = Number(updated[index].costoUSD || updated[index].costo || 0);
  const cantidad = Number(updated[index].cantidad || 0);
  const cbm = Number(value || 0);

  // const fobPesos = costoUSD * promedioTipoCambioGastos;
  const fobPesos = costoUSD * tipoCambioArticulos;
  const totalCBMUSD = costoCBMUSDGlobal * cbm;
  // const totalCBMPesos = totalCBMUSD * promedioTipoCambioGastos;
  const totalCBMPesos = totalCBMUSD * tipoCambioArticulos;
  const pasadaPorPiezaUSD = cantidad > 0 ? totalCBMUSD / cantidad : 0;
  const pasadaPorPiezaPesos = cantidad > 0 ? totalCBMPesos / cantidad : 0;
  const costoUSDTotal = costoUSD + pasadaPorPiezaUSD;
  const costoPesosTotal = fobPesos + pasadaPorPiezaPesos;
  const total = costoPesosTotal * cantidad;

  updated[index].fobPesos = fobPesos;
  updated[index].costoCBMUSD = costoCBMUSDGlobal;
  updated[index].costoCBMPesos = costoCBMPesosGlobal;
  updated[index].totalCBMUSD = totalCBMUSD;
  updated[index].totalCBMPesos = totalCBMPesos;
  updated[index].pasadaPorPiezaUSD = pasadaPorPiezaUSD;
  updated[index].pasadaPorPiezaPesos = pasadaPorPiezaPesos;
  updated[index].costoUSDTotal = costoUSDTotal;
  updated[index].costoPesosTotal = costoPesosTotal; // rojo
  updated[index].total = total;

  setInputFieldsNuevos(updated);
};
  const handleComisionChangeNuevos = (index, value) => {
    const nuevosArticulos = [...inputFieldsNuevos];
    const porcentaje = parseFloat(value) || 0;
    const fob = parseFloat(nuevosArticulos[index].costoUSD) || 0;
  
    nuevosArticulos[index].comisionVendedorPorcentaje = porcentaje;
    nuevosArticulos[index].comisionVendedorCantidad = (fob * porcentaje) / 100;
  
    setInputFieldsNuevos(nuevosArticulos);
  };


const saveFOBEmbarque = async (event, costear = false, yaRecibido = false) => {
  event.preventDefault();
  setValidaBoton(false);
  toggleProgreso();

  try {
    // 1. PATCH de artículos del embarque (FOB, CBM, comisiones)
    await Promise.all(
      articulosPedido.map((a) =>
        axios.patch(
          `${URL_ARTICULOS_EMBARQUES}EditFOB/${a.id}`,
          {
            costoUSD: parseFloat(a.costoUSD || 0),
            CBM: parseFloat(a.CBM || 0),
            comisionVendedorPorcentaje: parseFloat(a.comisionVendedorPorcentaje || 0),
            comisionVendedorCantidad: parseFloat(a.comisionVendedorCantidad || 0),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      )
    );

    // 2. PATCH a colección articulos usando idArticulo
if (costear) {
  await Promise.all(
    articulosPedido
      .filter((a) => a.idArticulos && a.idArticulos !== "")
      .map(async (a) => {
        const calc = calcularFilaCosteo(a);
        // Promedio ponderado con la existencia actual (lo calcula el back)
        const response = await axios.patch(
          `${URL_ARTICULOS}CostoPromedio/${a.idArticulos}`,
          {
            cantidadEntrante: Number(a.cantidad || 0),
            costoEntrante: parseFloat(calc.costoPesosTotal.toFixed(2)),
            yaRecibido: yaRecibido,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        return response;
      })
  );
}

    // 3. PATCH al embarque principal
    await axios.patch(
      `${URL_EMBARQUES}/${idEdit}`,
      {
        total_cantidad: totalCantidadEdit,
        total_costo: parseFloat(totalGeneralEdit || 0).toFixed(2),
        saldo: parseFloat(totalGeneralEdit || 0).toFixed(2),
        gasto1Concepto: gasto1Concepto,
        gasto1USD: parseFloat(gasto1USD || 0),
        gasto1TC: parseFloat(gasto1TC || 0),
        gasto1MXN: Number(gasto1USD || 0) * Number(gasto1TC || 0),

        gasto2Concepto: gasto2Concepto,
        gasto2USD: parseFloat(gasto2USD || 0),
        gasto2TC: parseFloat(gasto2TC || 0),
        gasto2MXN: Number(gasto2USD || 0) * Number(gasto2TC || 0),

        gasto3Concepto: gasto3Concepto,
        gasto3USD: parseFloat(gasto3USD || 0),
        gasto3TC: parseFloat(gasto3TC || 0),
        gasto3MXN: Number(gasto3USD || 0) * Number(gasto3TC || 0),

        gasto4Concepto: gasto4Concepto,
        gasto4USD: parseFloat(gasto4USD || 0),
        gasto4TC: parseFloat(gasto4TC || 0),
        gasto4MXN: Number(gasto4USD || 0) * Number(gasto4TC || 0),

        ...(costear && { costeado: "Si" }) // 🔥 SOLO SI ES COSTEAR
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    // Verificar si hay artículos nuevos válidos
    const nuevosConArticulo = inputFieldsNuevos.filter(
      (a) => a.articulos !== "" || a.articulosOrden !== ""
    );

    if (nuevosConArticulo.length > 0) {
      // 4. Agrupar nuevos artículos por proveedor
      const agrupadoPorProveedor = [];
      nuevosConArticulo.forEach((a) => {
        const existente = agrupadoPorProveedor.find(
          (p) => p.proveedor === a.proveedorOrden
        );

        const calc = calcularFilaCosteo(a);

        if (existente) {
          existente.cantidad += Number(a.cantidad || 0);
          existente.costoTotal += Number(calc.total || 0);
        } else {
          agrupadoPorProveedor.push({
            proveedor: a.proveedorOrden,
            cantidad: Number(a.cantidad || 0),
            costoTotal: Number(calc.total || 0),
          });
        }
      });

      // 5. Crear nueva Nota CxP
      const notaCxPGuardada = await axios
        .post(
          `${URL_NOTAS_CXP}`,
          {
            proveedores: nuevosConArticulo[0].proveedorOrden,
            embarques: idEdit,
            total_cantidad: totalCantidadEdit,
            total_costo: parseFloat(totalGeneralEdit || 0).toFixed(2),
            saldo: parseFloat(totalGeneralEdit || 0).toFixed(2),
            calidad: "No",
            fecha: hoy,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((res) => res.data);

      // 6. Insertar nuevos artículos al embarque con la nota ligada
      await Promise.all(
        nuevosConArticulo.map((a) => {
          const calc = calcularFilaCosteo(a);

          return axios.post(
            `${URL_ARTICULOS_EMBARQUES}`,
            {
              articulosOC: a.articulosOrden,
              articulos: a.articulos,
              cantidad: Number(a.cantidad || 0),
              CBM: Number(a.CBM || 0),
              recibido: 0,
              pendiente_recibir: Number(a.cantidad || 0),
              embarques: idEdit,
              notasCxP: notaCxPGuardada._id.toString(),
              costo: Number(a.costo || a.costoUSD || 0),
              total_costo: Number(calc.total || 0),
              proveedores: a.proveedorOrden,
              faltante: 0,
              danado: 0,
              impuestos: 0,
              revisarFaltante: 10,
              revisarDanado: 10,
              pedirFaltante: 0,
              pedirDanado: 10,
              faltanteTotal: 0,
              danadoTotal: 0,
              descuentoFaltante: 0,
              descuentoDanado: 0,
              descuentoTotal: 0,
              familias: "NA",
              sup: "NA",
              observaciones: "NA",
              calidad: "No",
              costoUSD: Number(a.costoUSD || a.costo || 0),
              comisionVendedorPorcentaje: Number(a.comisionVendedorPorcentaje || 0),
              comisionVendedorCantidad: Number(a.comisionVendedorCantidad || 0),
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
        })
      );

      // 7. PATCH a colección articulos para nuevos artículos
     if (costear) {
  await Promise.all(
    nuevosConArticulo
      .filter((a) => a.articulos)
      .map((a) => {
        const calc = calcularFilaCosteo(a);
        // Promedio ponderado con la existencia actual (lo calcula el back)
        return axios.patch(
          `${URL_ARTICULOS}CostoPromedio/${a.articulos}`,
          {
            cantidadEntrante: Number(a.cantidad || 0),
            costoEntrante: parseFloat(calc.costoPesosTotal.toFixed(2)),
            yaRecibido: yaRecibido,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
      })
  );
}

      // 8. PATCH a artículos OC acumulados
      await Promise.all(
        nuevosConArticulo.map((w) =>
          axios.patch(
            `${URL_ARTICULOS_OC_ACUMULADOS}editEmbarcado/${w.articulosOrden}`,
            {
              embarcado: Number(w.cantidad || 0),
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
        )
      );
    }

    // 9. Guardar log
    await axios.post(
      URL_LOGS,
      {
        tipo: "Editar Articulos Embarque",
        detalle: `${idEdit}`,
        user: user.id,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    Swal.fire("¡Correcto!", "Actualización exitosa", "success");
  } catch (error) {
    console.error("Error en la actualización:", error);
    Swal.fire("Error", "Hubo un problema al guardar algunos artículos", "warning");
  }

  setModalProgreso(false);
  setValidaBoton(true);
};


  function EditGastos(id, total_gasto) {
    setGastosEmbarquesTotales(total_gasto);
    axios
      .get(`${URL_GASTOS_EMBARQUES}Embarque/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allGastosEmbarque = res.data;
        setGastosEmbarque(allGastosEmbarque);
      })
      .catch((err) => {
        console.log(err);
      });

    setInputFieldsGastos([
      {
        id: uuidv4(),
        concepto: "",
        estimado: 0,
        real: 0,
      },
    ]);
    setIdEdit(id);

    toggleEditGastos();
  }

  function costear(id) {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Se realizará el costeo del embarque. Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, costear embarque",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${URL_EMBARQUES}Costear/${id}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            Swal.fire({
              title: "¡Listo!",
              text: "El embarque fue costeado correctamente.",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
          })
          .catch((err) => {
            console.error(err);
            Swal.fire({
              title: "Error",
              text: "Ocurrió un error al costear el embarque.",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          });
  
        setIdEdit(id);
      }
    });
  }
  

  const handleRemoveFieldsGastos = (id) => {
    const values = [...inputFieldsGastos];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsGastos(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidadGastos(TC);
  };

  const handleAddFieldsGastos = () => {
    setInputFieldsGastos([
      ...inputFieldsGastos,
      {
        id: uuidv4(),
        concepto: "",
        estimado: 0,
        real: 0,
      },
    ]);
  };

  const handleChangeInputGastos = (id, event) => {
    const newInputFieldsGastos = inputFieldsGastos.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsGastos(newInputFieldsGastos);
    ActualizaTotalesGastos()
  };

  const handleChangeInputGastosExistentes = (id, event) => {
    const newGastosEmbarque = gastosEmbarque.map((i) => {
      if (id === i._id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setGastosEmbarque(newGastosEmbarque);
    ActualizaTotalesGastos()
  };

  function ActualizaTotalesGastos() {
    let TEfe = gastosEmbarque.map((c) => parseFloat(c.real));
    let TE = TEfe.reduce((t, total, index) => t + total, 0);

    let TEfeNC = inputFieldsGastos.map((c) => parseFloat(c.real));
    let TENC = TEfeNC.reduce((t, total, index) => t + total, 0);

    let TF = parseFloat(TE).toFixed(2)
    let TFNC = parseFloat(TENC).toFixed(2)

    let sum = (parseFloat(TF) + parseFloat(TFNC)).toFixed(2)

    setGastosEmbarquesTotales(sum);

  }

  function BuscaGasto(id, event) {
    if (
      inputFieldsGastos.filter((e) => e.concepto == event.target.value).length >
      0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El gasto ya fue capturado!",
        showConfirmButton: false,
      });
      const newInputFieldsGastos = inputFieldsGastos.map((i) => {
        if (id === i.id) {
          i.concepto = "";
        }
        return i;
      });
      setInputFieldsGastos(newInputFieldsGastos);
    } else {
      conceptosGastos.map((a) => {
        if (a._id == event.target.value) {
          let concepto = a._id;
          let estimado = a.estimado;
          handleChangeInputGasto(id, concepto, estimado);
        }
      });
    }
  }
  const handleChangeInputGasto = (id, concepto, estimado) => {
    const newInputFieldsGasto = inputFieldsGastos.map((i) => {
      if (id === i.id) {
        i.concepto = concepto;
        i.estimado = estimado;
        i.real = estimado;
      }
      return i;
    });
    setInputFieldsGastos(newInputFieldsGasto);
  };

  const saveGastosEmbarque = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();
    let totalEmbarques = inputFieldsGastos.length + gastosEmbarque.length;
    try {
      await inputFieldsGastos.map((a) => {
        if (a.concepto != "") {
          axios
            .post(
              URL_GASTOS_EMBARQUES,
              {
                conceptosGastosEmbarques: a.concepto,
                estimado: a.estimado,
                real: a.real,
                embarques: idEdit,
                gastosEmbarquesTotales
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              totalEmbarques = totalEmbarques - 1;
              if (totalEmbarques == 0) {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Editar Gastos Embarque",
                    detalle: `${idEdit}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire("Good job!", "Creado con exito", `success`);
                 setValidaBoton(true);
              setModalProgreso(false)  
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        } else {
          totalEmbarques = totalEmbarques - 1;
          if (totalEmbarques == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Gastos",
                detalle: `${idEdit}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
             setValidaBoton(true);  
              setModalProgreso(false)
            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          }
        }
      });

      gastosEmbarque.map((a) => {
        if (a.concepto != "") {
          axios
            .patch(
              `${URL_GASTOS_EMBARQUES}/${a._id}`,
              {
                estimado: a.estimado,
                real: a.real,
                embarques: idEdit,
                gastosEmbarquesTotales
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              totalEmbarques = totalEmbarques - 1;
              if (totalEmbarques == 0) {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Editar Gastos Embarque",
                    detalle: `${idEdit}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire("Good job!", "Creado con exito", `success`);
                 setValidaBoton(true);  
              setModalProgreso(false)
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        } else {
          totalEmbarques = totalEmbarques - 1;
          if (totalEmbarques == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Gastos",
                detalle: `${idEdit}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
             setValidaBoton(true); 
              setModalProgreso(false) 
            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          }
        }
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  // function EditArticulos(idOC, contenedor, idProveedor, idContenedor) {
  //   setInputFields([
  //     {
  //       id: uuidv4(),
  //       articulosOrden: "",
  //       articulos: "",
  //       cantidad: 0,
  //       cantidadAnterior: 0,
  //       piezasPorCaja: 0,
  //       cajas: 0,
  //       cantidadOC: 0,
  //       costo: 0,
  //       costoTotal: 0,
  //       proveedorOrden: "",
  //       notasCxP: "",
  //     },
  //   ]);
  //   setInputFieldsNuevos([
  //     {
  //       id: uuidv4(),
  //       articulosOrden: "",
  //       articulos: "",
  //       cantidad: 0,
  //       piezasPorCaja: 0,
  //       cajas: 0,
  //       cantidadOC: 0,
  //       costo: 0,
  //       costoTotal: 0,
  //       proveedorOrden: idProveedor,
  //       ordenCompra: ""
  //     },
  //   ]);
  //   setIdArtEdit(idOC);
  //   setContenedorEdit(contenedor);
  //   setIdProveedor(idProveedor);
  //   setIdContenedor(idContenedor);
  //   setIdNotaCxP("");
  //   axios
  //     .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosOrden = response.data;
  //       let arrayTabla = allArticulosOrden
  //         .map((a) => {
  //           return {
  //             id: a._id,
  //             articulosOrden: a.articulosOC[0]._id,
  //             articulos: a.articulos[0]._id,
  //             cantidad: a.cantidad,
  //             cantidadAnterior: a.cantidad,
  //             piezasPorCaja: a.articulos[0].piezasPorCaja,
  //             cajas:
  //               parseFloat(a.cantidad) /
  //               parseFloat(a.articulos[0].piezasPorCaja),
  //             cantidadOC: a.articulosOC[0].cantidad,
  //             costo: a.costo,
  //             costoTotal: a.total_costo,
  //             proveedorOrden: a.proveedores[0]._id,
  //             notasCxP: a.notasCxP[0]._id,
  //             costoNotasCxP: a.notasCxP[0].total_costo,
  //             saldoNotasCxP: a.notasCxP[0].saldo,
  //             ordenCompra: a.articulosOC[0].ordenesCompra[0]._id,
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });
  //       let dataFinal = Object.values(arrayTabla);
  //       setArticulosOrden(dataFinal);
  //       let cant = dataFinal.map((c) => parseFloat(c.cantidad));
  //       let TC = cant.reduce((t, total, index) => t + total, 0);
  //       setTotalCantidadEdit(TC);
  //       let importes = dataFinal.map((c) => parseFloat(c.total));
  //       let TG = importes.reduce((t, total, index) => t + total, 0);
  //       setTotalGeneralEdit(TG);

  //       let nota = dataFinal.map((c) => c.notasCxP);
  //       // let nota = dataFinal.map((c) => c.notasCxP);
  //       // let notaTT = nota[0].reduce((t, total, index) => t + total, 0);
  //       setIdNotaCxP(nota[0]);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  //   toggleEditArticulos();
  // }

 function ActualizaTotales() {
  // Total cantidades de artículos existentes
  let cant = articulosPedido.map((c) => parseFloat(c.cantidad));
  let TC = cant.reduce((t, total) => t + total, 0);

  // Total costos de artículos existentes
  let cos = articulosPedido.map((c) => parseFloat(c.total));
  let TCos = cos.reduce((t, total) => t + total, 0);

  // Filtrar artículos nuevos válidos
  const nuevosConArticulo = inputFieldsNuevos.filter((c) => c.articulos !== "");

  if (nuevosConArticulo.length > 0) {
    // Sumar cantidades de artículos nuevos
    let cantNu = nuevosConArticulo.map((c) => parseFloat(c.cantidad));
    let TCNu = cantNu.reduce((t, total) => t + total, 0);

    // Sumar costos de artículos nuevos
    let cosNu = nuevosConArticulo.map((c) => parseFloat(c.costoTotal));
    let TCosNu = cosNu.reduce((t, total) => t + total, 0);

    // Totales combinados
    setTotalCantidadEdit(TC + TCNu);
    setTotalGeneralEdit(TCos + TCosNu);
  } else {
    // Solo tomar en cuenta los actuales
    setTotalCantidadEdit(TC);
    setTotalGeneralEdit(TCos);
  }

  // Agrupación por notaCxP para artículos existentes
  let agrupado = articulosPedido.reduce(function (groups, item) {
    const val = item["notasCxP"];
    groups[val] = groups[val] || {
      notasCxP: item.notasCxP,
      costoTotal: 0,
      cantidad: 0,
    };
    groups[val].proveedorOrden = item.proveedorOrden;
    groups[val].costoTotal += item.costoTotal;
    groups[val].cantidad += item.cantidad;
    groups[val].notasCxP = item.notasCxP;
    groups[val].saldoNotasCxP = item.saldoNotasCxP;
    groups[val].costoNotasCxP = item.costoNotasCxP;
    return groups;
  }, []);
  
  let temp = Object.values(agrupado);
  setAgrupado(temp);
}


  const handleChangeInputCantidad = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        i.costoTotal = parseFloat(event.target.value) * parseFloat(i.costo);
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const handleChangeInputCantidadCajas = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        let cantTemp =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i[event.target.name] = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i.costoTotal =
          parseFloat(event.target.value) *
          parseFloat(i.piezasPorCaja) *
          parseFloat(i.costo);
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const saveEditArt = async (event) => {
    event.preventDefault();

    setValidaBoton(false);
    toggleProgreso();

    let totalArticulos = articulosOrden.length + articulosOrden.length + agrupado.length + inputFieldsNuevos.length + inputFieldsNuevos.length
    let TCosto = articulosOrden.map((c) => parseFloat(c.costoTotal));
    let TTC = TCosto.reduce((t, total, index) => t + total, 0);

    let TCostoNuevo = inputFieldsNuevos.map((c) => parseFloat(c.costoTotal));
    let TTCNu = TCostoNuevo.reduce((t, total, index) => t + total, 0);

    let TCantNuevo = inputFieldsNuevos.map((c) => parseFloat(c.cantidad));
    let TTCantNu = TCantNuevo.reduce((t, total, index) => t + total, 0);

    let totalTotal = TTC + TTCNu
    try {
      await axios
        .patch(
          `${URL_EMBARQUES}/${idArtEdit}`,
          {
            total_cantidad: totalCantidadEdit,
            total_costo: parseFloat(totalTotal).toFixed(2),
            saldo: parseFloat(totalTotal).toFixed(2),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          agrupado.map((b) => {
            axios
              .patch(
                `${URL_NOTAS_CXP}editEmbarque/${idNotaCxP}`,
                {
                  proveedores: b.proveedorOrden,
                  total_cantidad: b.cantidad + TTCantNu,
                  total_costo: parseFloat(totalTotal).toFixed(2),
                  saldo:
                    parseFloat(b.saldoNotasCxP) -
                    parseFloat(b.costoNotasCxP) +
                    parseFloat(b.costoTotal) +
                    parseFloat(TTCNu),
                  difSaldo:
                    parseFloat(b.costoTotal + TTCNu) - parseFloat(b.costoNotasCxP),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Editar Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire(
                        "Good job!",
                        "Creado con exito",
                        "success"
                      );
                       setValidaBoton(true);  
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });

            // Acaba el primer map
          });

          articulosOrden.map((j) => {
            axios
              .patch(
                `${URL_ARTICULOS_EMBARQUES}EditCant/${j.id}`,
                {
                  cantidad: j.cantidad - j.cantidadAnterior,
                  total_costo: j.costoTotal,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire(
                        "Good job!",
                        "Creado con exito",
                        "success"
                      );
                       setValidaBoton(true);  
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          });

          articulosOrden.map((w) => {
            axios
              .patch(
                `${URL_ARTICULOS_OC}editEmbarcadoCant/${w.articulosOrden}`,
                {
                  embarcado: w.cantidad - w.cantidadAnterior,
                  ordenesCompra: w.ordenCompra
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                       setValidaBoton(true);  
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          });

          // Acaba el segundo map
        })
        // Catch primer then
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });

        // Articulos Nuevos
        inputFieldsNuevos.map((a) => {
          if (
            a.articulos != "" &&
            a.cantidad != 0 
          ) {
            axios
              .post(
                `${URL_ARTICULOS_EMBARQUES}`,
                {
                  articulosOC: a.articulosOrden,
                  articulos: a.articulos,
                  cantidad: a.cantidad,
                  recibido: 0,
                  pendiente_recibir: a.cantidad,
                  embarques: idArtEdit,
                  notasCxP: idNotaCxP,
                  costo: a.costo,
                  total_costo: a.costoTotal,
                  proveedores: idProveedor,
                  faltante: 0,
                  danado: 0,
                  impuestos: 0,
                  revisarFaltante: 10,
                  revisarDanado: 10,
                  pedirFaltante: 0,
                  pedirDanado: 10,
                  faltanteTotal: 0,
                  danadoTotal: 0,
                  descuentoFaltante: 0,
                  descuentoDanado: 0,
                  descuentoTotal: 0,
                  familias: "NA",
                  sup: "NA",
                  observaciones:"NA",
                  calidad:"No"
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire(
                        "Good job!",
                        "Creado con exito",
                        "success"
                      );
                       setValidaBoton(true);  
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          } else {
            totalArticulos = totalArticulos - 1;
            if (totalArticulos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Crear Embarque",
                    detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire(
                    "Good job!",
                    "Creado con exito",
                    "success"
                  );
                   setValidaBoton(true);  
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });

        inputFieldsNuevos.map((w) => {
          if (
            w.articulos != "" &&
            w.cantidad != 0 
          ) {
          axios
            .patch(
              `${URL_ARTICULOS_OC}editEmbarcado/${w.articulosOrden}`,
              {
                embarcado: w.cantidad,
                ordenesCompra: w.ordenCompra
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            )
            .then(() => {
              totalArticulos = totalArticulos - 1;
              if (totalArticulos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Embarque",
                      detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                     setValidaBoton(true);  
                    // setTimeout(() => {
                    //   window.location.reload();
                    // }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
              setValidaBoton(true);
            });
          } else {
            totalArticulos = totalArticulos - 1;
            if (totalArticulos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Crear Embarque",
                    detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire(
                    "Good job!",
                    "Creado con exito",
                    "success"
                  );
                   setValidaBoton(true);  
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });


    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        // footer: `${error.response.data}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

function BuscaArticulo(id, event) {
  const idArticuloSeleccionado = event.target.value;
  const articuloOC = articulosOC.find((a) => a._id === idArticuloSeleccionado);

  if (!articuloOC) return;

  const idArticulo = articuloOC.articulos[0]._id;

  // Verificar si ya existe en inputFieldsNuevos
  const yaExisteEnNuevos = inputFieldsNuevos.some(
    (i) => i.articulos === idArticulo
  );

  // Verificar si ya existe en articulosPedido
  const yaExisteEnPedido = articulosPedido.some(
    (i) => i.idArticulos === idArticulo
  );

  if (yaExisteEnNuevos || yaExisteEnPedido) {
    Swal.fire({
      icon: "warning",
      title: "Artículo ya agregado",
      text: "Este artículo ya se encuentra en la lista.",
    });
    return;
  }

  let articulosOrden = articuloOC._id;
  let articulos = idArticulo;
  let cantidad = articuloOC.pendiente_embarcar;
  let pendEmbarcar = articuloOC.pendiente_embarcar;
  let piezasPorCaja = articuloOC.articulos[0].piezasPorCaja;
  let cajas = articuloOC.cantidad / piezasPorCaja;
  let cantidadOC = articuloOC.cantidad;
  let costo = articuloOC.articulos[0].costoUSD;
  let costoUSD = articuloOC.articulos[0].costoUSD;
  let costoTotal = cantidadOC * costo;
  let proveedorOrden = idProveedorEdit;

  handleChangeInputArticulo(
    id,
    articulosOrden,
    articulos,
    cantidad,
    pendEmbarcar,
    piezasPorCaja,
    cajas,
    cantidadOC,
    costo,
    costoUSD,
    costoTotal,
    proveedorOrden
  );
}


  const handleChangeInputArticulo = (id, articulosOrden, articulos, cantidad, pendEmbarcar, piezasPorCaja, cajas, cantidadOC, costo, costoUSD, costoTotal, proveedorOrden) => {
    const newInputFields = inputFieldsNuevos.map((i) => {
      if (id === i.id) {
        i.articulosOrden = articulosOrden;
        i.articulos = articulos;
        i.cantidad = cantidad;
        i.pendEmbarcar = pendEmbarcar;
        i.piezasPorCaja = piezasPorCaja;
        i.cajas = cajas;
        i.cantidadOC = cantidadOC;
        i.costo = costo;
        i.costoUSD = costoUSD;
        i.costoTotal = costoTotal;
        i.proveedorOrden = proveedorOrden;
        i.CBM = 0;
        i.comisionVendedorPorcentaje = 0;
        i.comisionVendedorCantidad = 0;
      }
      return i;
    });
    setInputFieldsNuevos(newInputFields);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    let TC = totalCaptura + 1;

    setTotalCaptura(TC);
    setInputFieldsNuevos([
      ...inputFieldsNuevos,
      {
        id: uuidv4(),
        articulosOrden: "",
        articulos: "",
        cantidad: 0,
        pendEmbarcar: 0,
        CBM: 0,
        piezasPorCaja: 0,
        cajas: 0,
        cantidadOC: 0,
        costo: 0,
        costoUSD: 0,
        costoTotal: 0,
        proveedorOrden: idProveedorEdit,
        comisionVendedorPorcentaje: 0,
        comisionVendedorCantidad: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFieldsNuevos];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsNuevos(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let agrupado = values.reduce(function (groups, item) {
      const val = item["proveedorOrden"];
      groups[val] = groups[val] || {
        proveedorOrden: item.proveedorOrden,
        costoTotal: 0,
        cantidad: 0,
      };
      groups[val].proveedorOrden = item.proveedorOrden;
      groups[val].costoTotal += item.costoTotal;
      groups[val].cantidad += item.cantidad;
      return groups;
    }, []);
    let temp = Object.values(agrupado)
 setAgrupado(temp)
  };

const handleChangeInputCosto = (event, id) => {
  const { value } = event.target;

  const updated = inputFieldsNuevos.map((item) => {
    if (item.id !== id) return item;

    const costoUSD = Number(value || 0);
    const cantidad = Number(item.cantidad || 0);
    const cbm = Number(item.CBM || 0);

    // const fobPesos = costoUSD * promedioTipoCambioGastos;
    const fobPesos = costoUSD * tipoCambioArticulos;
    const totalCBMUSD = costoCBMUSDGlobal * cbm;
    // const totalCBMPesos = totalCBMUSD * promedioTipoCambioGastos;
    const totalCBMPesos = totalCBMUSD * tipoCambioArticulos;
    const pasadaPorPiezaUSD = cantidad > 0 ? totalCBMUSD / cantidad : 0;
    const pasadaPorPiezaPesos = cantidad > 0 ? totalCBMPesos / cantidad : 0;
    const costoUSDTotal = costoUSD + pasadaPorPiezaUSD;
    const costoPesosTotal = fobPesos + pasadaPorPiezaPesos;
    const total = costoPesosTotal * cantidad;

    return {
      ...item,
      costo: value,
      costoUSD: value,
      fobPesos,
      costoCBMUSD: costoCBMUSDGlobal,
      costoCBMPesos: costoCBMPesosGlobal,
      totalCBMUSD,
      totalCBMPesos,
      pasadaPorPiezaUSD,
      pasadaPorPiezaPesos,
      costoUSDTotal,
      costoPesosTotal, // rojo
      total,
    };
  });

  setInputFieldsNuevos(updated);
};

  function BuscaOrden(id, event) {
    articulosOC.map((a) => {
      if (a._id == event.target.value) {
        let articulosOrden = a._id;
        let cantidadOC = a.cantidad;
        let costo = a.precio
        let ordenCompra = a.ordenesCompra[0]._id
        handleChangeInputOC(id, articulosOrden, cantidadOC, costo, ordenCompra);
      }
    });
  }
  const handleChangeInputOC = (id, articulosOrden, cantidadOC, costo, ordenCompra) => {
    const newInputFieldsNuevos = inputFieldsNuevos.map((i) => {
      if (id === i.id) {
        i.articulosOrden = articulosOrden;
        i.cantidadOC = cantidadOC;
        i.costo = costo;
        i.costoTotal = parseFloat(costo) * parseFloat(i.cantidad);
        i.ordenCompra = ordenCompra;
      }
      return i;
    });
    setInputFieldsNuevos(newInputFieldsNuevos);
    ActualizaTotales();
  };
const handleChangeInputCantidadNuevos = (id, event) => {
  const { value } = event.target;

  const updated = inputFieldsNuevos.map((item) => {
    if (item.id !== id) return item;

    const costoUSD = Number(item.costoUSD || item.costo || 0);
    const cantidad = Number(value || 0);
    const cbm = Number(item.CBM || 0);

    // const fobPesos = costoUSD * promedioTipoCambioGastos;
    const fobPesos = costoUSD * tipoCambioArticulos;
    const totalCBMUSD = costoCBMUSDGlobal * cbm;
    // const totalCBMPesos = totalCBMUSD * promedioTipoCambioGastos;
    const totalCBMPesos = totalCBMUSD * tipoCambioArticulos;
    const pasadaPorPiezaUSD = cantidad > 0 ? totalCBMUSD / cantidad : 0;
    const pasadaPorPiezaPesos = cantidad > 0 ? totalCBMPesos / cantidad : 0;
    const costoUSDTotal = costoUSD + pasadaPorPiezaUSD;
    const costoPesosTotal = fobPesos + pasadaPorPiezaPesos;
    const total = costoPesosTotal * cantidad;

    return {
      ...item,
      cantidad: value,
      fobPesos,
      costoCBMUSD: costoCBMUSDGlobal,
      costoCBMPesos: costoCBMPesosGlobal,
      totalCBMUSD,
      totalCBMPesos,
      pasadaPorPiezaUSD,
      pasadaPorPiezaPesos,
      costoUSDTotal,
      costoPesosTotal, // rojo
      total,
    };
  });

  setInputFieldsNuevos(updated);
};

  const handleChangeInputCantidadCajasNuevos = (id, event) => {
    const newInputFieldsNuevos = inputFieldsNuevos.map((i) => {
      if (id === i.id) {
        let cantTemp =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i[event.target.name] = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i.costoTotal =
          parseFloat(event.target.value) *
          parseFloat(i.piezasPorCaja) *
          parseFloat(i.costo);
      }
      return i;
    });
    setInputFieldsNuevos(newInputFieldsNuevos);
    ActualizaTotales();
  };

  const totalUSDGastos =
  Number(gasto1USD || 0) +
  Number(gasto2USD || 0) +
  Number(gasto3USD || 0) +
  Number(gasto4USD || 0);

const totalPesosGastos =
  Number(gasto1USD || 0) * Number(gasto1TC || 0) +
  Number(gasto2USD || 0) * Number(gasto2TC || 0) +
  Number(gasto3USD || 0) * Number(gasto3TC || 0) +
  Number(gasto4USD || 0) * Number(gasto4TC || 0);

const promedioTipoCambioGastos =
  totalUSDGastos > 0 ? totalPesosGastos / totalUSDGastos : 0;

const totalCBMExistentes = articulosPedido.reduce(
  (acc, item) => acc + Number(item.CBM || 0),
  0
);

const totalCBMNuevos = inputFieldsNuevos.reduce(
  (acc, item) => acc + Number(item.CBM || 0),
  0
);

const totalCBMGlobal = totalCBMExistentes + totalCBMNuevos;

const costoCBMUSDGlobal =
  totalCBMGlobal > 0 ? totalUSDGastos / totalCBMGlobal : 0;

const costoCBMPesosGlobal =
  totalCBMGlobal > 0 ? totalPesosGastos / totalCBMGlobal : 0;

const calcularFilaCosteo = (item) => {
  const fobUSD = Number(item.costoUSD || item.costo || 0);
  const cantidad = Number(item.cantidad || 0);
  const cbm = Number(item.CBM || 0);

  // const fobPesos = fobUSD * promedioTipoCambioGastos;
  const fobPesos = fobUSD * tipoCambioArticulos;

  const totalCBMUSD = cbm * costoCBMUSDGlobal;
  const totalCBMPesos = cbm * costoCBMPesosGlobal;

  const pasadaPorPiezaUSD = cantidad > 0 ? totalCBMUSD / cantidad : 0;
  const pasadaPorPiezaPesos = cantidad > 0 ? totalCBMPesos / cantidad : 0;

  const costoUSDTotal = fobUSD + pasadaPorPiezaUSD;
  const costoPesosTotal = fobPesos + pasadaPorPiezaPesos;

  const total = costoPesosTotal * cantidad;

  return {
    fobUSD,
    fobPesos,
    cantidad,
    cbm,
    costoCBMUSD: costoCBMUSDGlobal,
    costoCBMPesos: costoCBMPesosGlobal,
    totalCBMUSD,
    totalCBMPesos,
    pasadaPorPiezaUSD,
    pasadaPorPiezaPesos,
    costoUSDTotal,
    costoPesosTotal,
    total,
  };
};

const formatMoney = (value) =>
  `$${Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.embarques ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.embarques ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/EmbarquesCreate"
                >
                  Nuevo Embarque
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Embarque
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                {/* <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={
                    e=>{
                      axios
                      .get(`${URL_ARTICULOS_EMBARQUES}Desarrollo`, {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      })
                      .then((response) => {
                        alert(response.data)
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                    }
                  }
                >
                  Desarrollo <i class="far fa-file-pdf"></i>
                </Button> */}
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes de Embarque</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Embarques</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio Embarque</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin Embarque</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>

            <Col md={2}>
              <Label>Recibido</Label>
              <Input
                bsSize="sm"
                type="select"
                value={recibido}
                required
                onChange={(e) => {
                  setRecibido(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Recibidos</option>
                <option value="No">No Recibidos</option>
              </Input>
            </Col>

             <Col md={2}>
              <Label>Costeado</Label>
              <Input
                bsSize="sm"
                type="select"
                value={costeado}
                required
                onChange={(e) => {
                  setCosteado(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr
                      style={
                        a.recibido == "Si"
                          ? { backgroundColor: "#64e379" }
                          : null
                      }
                    >
                      <td>{a.is_active}</td>
                      <td>{a.recibido}</td>
                      <td>{a.costeado}</td>
                      <td>{a.numero}</td>
                      <td>{a.fechaEmbarque}</td>
                      <td>{a.proveedor}</td>
                      <td>{a.contenedor}</td>
                      <td>{a.numeroInterno}</td>
                      <td>{a.fechaEstimada}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.totalCantidad)}
                      </td>
                      <td>
                        {user.embarques ? (
                          <div>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fechaEmbarque,
                                  a.contenedor,
                                  a.numeroInterno,
                                  a.fechaEstimada,
                                  a.creado,
                                  a._id,
                                  a.numero,
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a.fechaEmbarque,
                                  a.fechaEstimada,
                                  a.numeroInterno,
                                  a.tipoCambioUSDMXN,
                                  a.observaciones,
                                  a.contenedor,
                                  a.idEmbarques,
                                  a.recibido,
                                  a._id,
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                            {/* {a.recibido == "No" ? ( */}
                            {/* <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) =>
                              EditArticulos(a._id, a.contenedor, a.idProveedor)
                            }
                          >
                            <i class="fas fa-cart-plus"></i>
                          </Button> */}
                            {/* ):undefined} */}

                            {user.inventarios_costos ? (
                              <>
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    EditArticulos(
                                      a._id,
                                      a.idProveedor,
                                      a.totalCantidad,
                                      a.total_costo,
                                      a.tipoCambioUSDMXN,
                                      a.gasto1Concepto,
                                      a.gasto1USD,
                                      a.gasto1TC,
                                      a.gasto1MXN,
                                      a.gasto2Concepto,
                                      a.gasto2USD,
                                      a.gasto2TC,
                                      a.gasto2MXN,
                                      a.gasto3Concepto,
                                      a.gasto3USD,
                                      a.gasto3TC,
                                      a.gasto3MXN,
                                      a.gasto4Concepto,
                                      a.gasto4USD,
                                      a.gasto4TC,
                                      a.gasto4MXN,
                                    )
                                  }
                                >
                                  <i class="fas fa-cart-plus"></i>
                                </Button>
                                {/* <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    EditGastos(a._id, a.total_gasto)
                                  }
                                >
                                  <i class="fas fa-dollar-sign"></i>
                                </Button>

                                <Button
                                  color={
                                    a.costeado === "Si" ? "success" : "warning"
                                  }
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => costear(a._id)}
                                >
                                  <i class="fas fa-calculator"></i>
                                </Button> */}
                              </>
                            ) : undefined}
                          </div>
                        ) : (
                          <div>
                            <Button color="info" id="Editar" size="sm" disabled>
                              <i class="far fa-edit"></i>
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Embarque # {numeroEmbarque}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Fecha Embarque</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fechaEmbarque}
                required
                onChange={(e) => {
                  setFechaEmbarque(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label># Contenedor</Label>
              <Input
                type="text"
                placeholder="contenedor"
                value={contenedor}
                required
                onChange={(e) => {
                  setContenedor(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Numero Interno</Label>
              <Input
                type="text"
                placeholder="NumeroInterno"
                value={numeroInterno}
                required
                onChange={(e) => {
                  setNumeroInterno(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Fecha Estimada de Arribo</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fechaEstimada}
                required
                onChange={(e) => {
                  setFechaEstimada(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Tipo Cambio USD MXN</Label>
              <Input
                type="number"
                placeholder="Fecha"
                value={tipoCambioUSDMXN}
                required
                onChange={(e) => {
                  setTipoCambioUSDMXN(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Recibido</Label>
              <Input
                type="select"
                value={recibidoEdit}
                onChange={(e) => {
                  setRecibidoEdit(e.target.value);
                }}
              >
                <option value={"No"}>No</option>
                <option value={"Si"}>Si</option>
              </Input>
            </Col>
            <Col md={8}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editEmbarques}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      {/* Modal editar Gastos */}

      <Modal size="xl" isOpen={modalEditGastos} toggle={toggleEditGastos}>
        <ModalHeader toggle={toggleEditGastos}>
          <h4>Editar Gastos Embarque</h4>
          <h4>Total: {gastosEmbarquesTotales}</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveGastosEmbarque}>
            <Row>
              <Col md={4}>
                <Label className="mr-sm-2">Concepto</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Estimado</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Real</Label>
              </Col>
            </Row>
            {gastosEmbarque.map((ae) => (
              <div key={ae._id}>
                <Row>
                  <Col md={4}>
                    <Input
                      bsSize="sm"
                      name="concepto"
                      type="select"
                      value={ae.conceptosGastosEmbarques[0]._id}
                      disabled
                    >
                      <option value="">Selecciona</option>
                      {conceptosGastos.map((a) => {
                        return <option value={a._id}>{a.concepto}</option>;
                      })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="estimado"
                      type="number"
                      min="0"
                      step="any"
                      value={ae.estimado}
                      onChange={(event) =>
                        handleChangeInputGastosExistentes(ae._id, event)
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="real"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="real"
                      value={ae.real}
                      onChange={(event) =>
                        handleChangeInputGastosExistentes(ae._id, event)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

            {/* Agregar articulos */}
            {inputFieldsGastos.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={4}>
                    <Input
                      bsSize="sm"
                      name="concepto"
                      type="select"
                      value={inputField.concepto}
                      onChange={(event) => BuscaGasto(inputField.id, event)}
                    >
                      <option value="">Selecciona</option>
                      {conceptosGastos.map((a) => {
                        return <option value={a._id}>{a.concepto}</option>;
                      })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="estimado"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.estimado}
                      onChange={(event) =>
                        handleChangeInputGastos(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="real"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="real"
                      value={inputField.real}
                      onChange={(event) =>
                        handleChangeInputGastos(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={setInputFieldsGastos.length === 1}
                      onClick={() => handleRemoveFieldsGastos(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsGastos}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

<Modal size="xxl" isOpen={modalEditFOB} toggle={toggleEditFOB}>
  <ModalHeader toggle={toggleEditFOB}>
    <h4>Editar y Costear Embarque</h4>
  </ModalHeader>

  <ModalBody>
<Form onSubmit={(e) => saveFOBEmbarque(e, false)}>

      {/* ================= GASTOS ================= */}
<div>
  <h4>Gastos</h4>

  <Row className="mb-2">
    <Col md={6}>
      <table className="table table-sm table-bordered">
        <thead>
          <tr>
            <th>Concepto</th>
            <th>USD</th>
            <th>TC</th>
            <th>MXN</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <Input
                bsSize="sm"
                type="text"
                value={gasto1Concepto}
                onChange={(e) => setGasto1Concepto(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={gasto1USD}
                onChange={(e) => setGasto1USD(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={gasto1TC}
                onChange={(e) => setGasto1TC(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={(Number(gasto1USD || 0) * Number(gasto1TC || 0)).toFixed(2)}
                disabled
              />
            </td>
          </tr>

          <tr>
            <td>
              <Input
                bsSize="sm"
                type="text"
                value={gasto2Concepto}
                onChange={(e) => setGasto2Concepto(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={gasto2USD}
                onChange={(e) => setGasto2USD(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={gasto2TC}
                onChange={(e) => setGasto2TC(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={(Number(gasto2USD || 0) * Number(gasto2TC || 0)).toFixed(2)}
                disabled
              />
            </td>
          </tr>

          <tr>
            <td>
              <Input
                bsSize="sm"
                type="text"
                value={gasto3Concepto}
                onChange={(e) => setGasto3Concepto(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={gasto3USD}
                onChange={(e) => setGasto3USD(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={gasto3TC}
                onChange={(e) => setGasto3TC(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={(Number(gasto3USD || 0) * Number(gasto3TC || 0)).toFixed(2)}
                disabled
              />
            </td>
          </tr>

          <tr>
            <td>
              <Input
                bsSize="sm"
                type="text"
                value={gasto4Concepto}
                onChange={(e) => setGasto4Concepto(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={gasto4USD}
                onChange={(e) => setGasto4USD(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={gasto4TC}
                onChange={(e) => setGasto4TC(e.target.value)}
              />
            </td>
            <td>
              <Input
                bsSize="sm"
                type="number"
                value={(Number(gasto4USD || 0) * Number(gasto4TC || 0)).toFixed(2)}
                disabled
              />
            </td>
          </tr>
        </tbody>

<tfoot>
  <tr>
    <th>
      <Input bsSize="sm" value="Totales" disabled />
    </th>

    {/* USD */}
    <th>
      <Input
        bsSize="sm"
        value={formatMoney(totalUSDGastos)}
        disabled
      />
    </th>

    {/* TC */}
    <th>
      <Input
        bsSize="sm"
        value={Number(promedioTipoCambioGastos || 0).toFixed(2)}
        disabled
      />
    </th>

    {/* MXN */}
    <th>
      <Input
        bsSize="sm"
        value={formatMoney(totalPesosGastos)}
        disabled
      />
    </th>
  </tr>
</tfoot>
      </table>
    </Col>
  </Row>
</div>

      {/* ================= RESUMEN CBM ================= */}
      <Row className="mb-3">
        {/* <Col md={1}>
          <Label>CBM Existentes</Label>
          <Input bsSize="sm" value={totalCBMExistentes.toFixed(2)} disabled />
        </Col> */}

        {/* <Col md={1}>
          <Label>CBM Nuevos</Label>
          <Input bsSize="sm" value={totalCBMNuevos.toFixed(2)} disabled />
        </Col> */}

        <Col md={1}>
          <Label>CBM Total</Label>
          <Input bsSize="sm" value={totalCBMGlobal.toFixed(2)} disabled />
        </Col>

        <Col md={1}>
  <Label>CBM USD</Label>
  <Input
    bsSize="sm"
    value={formatMoney(costoCBMUSDGlobal)}
    disabled
  />
</Col>

<Col md={1}>
  <Label>CBM MXN</Label>
  <Input
    bsSize="sm"
    value={formatMoney(costoCBMPesosGlobal)}
    disabled
  />
</Col>

<Col md={1}>
  <Label>TC Articulos</Label>
  <Input
    bsSize="sm"
    type="number"
    value={tipoCambioArticulos}
    onChange={(e) => setTipoCambioArticulos(e.target.value)}
  />
</Col>

      </Row>

      {/* ================= TABLA ================= */}
      <div>
        <h4>Artículos Embarque</h4>

        <table className="table table-sm table-bordered">
          <thead>
            <tr>
              <th>SKU</th>
              <th>FOB USD</th>
              <th>TC</th>
              <th>FOB MXN</th>
              <th>Piezas</th>
              <th>CBM</th>
              <th>CBM USD</th>
              <th>CBM MXN</th>
              <th>Total CBM USD</th>
              <th>Total CBM MXN</th>
              <th>Px USD</th>
              <th>Px MXN</th>
              <th>Costo USD</th>
              <th>Costo MXN</th>
              <th>Total</th>
              <th>Acción</th>
            </tr>
          </thead>

<tbody>
  {articulosPedido.map((ae, index) => {
    const calc = calcularFilaCosteo(ae);

    return (
      <tr key={ae._id}>
        <td>{ae.articulo}</td>

        <td>
          <Input
            bsSize="sm"
            value={ae.costoUSD}
            onChange={(e) => handleCostoChange(index, e.target.value)}
          />
        </td>

        {/* <td>{formatMoney(promedioTipoCambioGastos)}</td> */}
        <td>{formatMoney(tipoCambioArticulos)}</td>

        <td>{formatMoney(calc.fobPesos)}</td>

        {/* 🔴 ESTE NO LLEVA $ */}
        <td>
          <Input
            bsSize="sm"
            type="number"
            min="0"
            step="any"
            value={ae.cantidad}
            disabled={Number(ae.recibido) > 0}
            onChange={(e) => handleCantidadChange(index, e.target.value)}
          />
        </td>

        <td>
          <Input
            bsSize="sm"
            value={ae.CBM}
            onChange={(e) => handleCBMChange(index, e.target.value)}
          />
        </td>

        <td>{formatMoney(calc.costoCBMUSD)}</td>
        <td>{formatMoney(calc.costoCBMPesos)}</td>
        <td>{formatMoney(calc.totalCBMUSD)}</td>
        <td>{formatMoney(calc.totalCBMPesos)}</td>
        <td>{formatMoney(calc.pasadaPorPiezaUSD)}</td>
        <td>{formatMoney(calc.pasadaPorPiezaPesos)}</td>
        <td>{formatMoney(calc.costoUSDTotal)}</td>

        <td style={{ background: "#f4cccc" }}>
          {formatMoney(calc.costoPesosTotal)}
        </td>

        <td>{formatMoney(calc.total)}</td>

        <td>
          {Number(ae.recibido) > 0 ? (
            <span className="badge badge-secondary">Recibido</span>
          ) : (
            <Button
              size="sm"
              color="success"
              type="button"
              onClick={() => guardarLineaNoRecibida(ae)}
              title="Guardar esta linea (cantidad / costo / CBM)"
            >
              <i className="fas fa-save"></i>
            </Button>
          )}
        </td>
      </tr>
    );
  })}
</tbody>

        </table>
      </div>

      <br />

     <Row>
  <Col>
    <Button
      type="button"
      className="btn btn-primary mr-2"
      disabled={!validaBoton}
      onClick={(e) => saveFOBEmbarque(e, false)}
    >
      Guardar
    </Button>

    <Button
      type="button"
      className="btn btn-success mr-2"
      disabled={!validaBoton}
      onClick={(e) => saveFOBEmbarque(e, true, false)}
      title="El embarque AÚN NO se ha recibido a inventario"
    >
      Costear (aún no recibido)
    </Button>

    <Button
      type="button"
      className="btn btn-warning"
      disabled={!validaBoton}
      onClick={(e) => saveFOBEmbarque(e, true, true)}
      title="El embarque YA se recibió a inventario"
    >
      Costear (ya recibido)
    </Button>
  </Col>
</Row>

    </Form>
  </ModalBody>
</Modal>
      {loader}
    </>
  );
}

export default ListadoEmbarques;